// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulppxbi{gap:var(--ds-space-200,1pc)}._19bvoahv{padding-left:var(--ds-space-600,3pc)}\n._4t3i16xz{height:6pc}\n._ca0q1jfw{padding-top:var(--ds-space-500,40px)}\n._n3td1jfw{padding-bottom:var(--ds-space-500,40px)}\n._u5f3oahv{padding-right:var(--ds-space-600,3pc)}\n._y3gn1h6o{text-align:center}", ""]);
// Exports
module.exports = exports;
